// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__Cilih","spin":"loader_spin__F9trx","loading_container":"loader_loading_container__p-1sp"};